export const isNotSet = (value: any) =>
  value === undefined || value === null || value === '' || (typeof value === 'number' && isNaN(value))

export const isSet = (value: any) => !isNotSet(value)

export const isNotNullOrUndefined = (value: any) => value !== undefined && value !== null
